import React from "react"

import { TextArea } from "components/atoms/Input"

const TextareaWidget = ({
  disabled,
  formContext,
  id,
  onBlur,
  onChange,
  onFocus,
  options,
  placeholder,
  readonly,
  value,
}) => {
  const { readonlyAsDisabled = true } = formContext

  const handleChange = ({ target }) => onChange(target.value === "" ? options.emptyValue : target.value)

  const handleBlur = ({ target }) => onBlur(id, target.value)

  const handleFocus = ({ target }) => onFocus(id, target.value)

  return (
    <TextArea
      disabled={disabled || (readonlyAsDisabled && readonly)}
      id={id}
      name={id}
      onBlur={!readonly ? handleBlur : undefined}
      onChange={!readonly ? handleChange : undefined}
      onFocus={!readonly ? handleFocus : undefined}
      placeholder={placeholder}
      rows={options.rows || 4}
      style={{ width: "100%" }}
      value={value}
    />
  )
}

export default TextareaWidget
